import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * This component now accepts a ref to a custom scrollbar component.
 * It uses the ref to imperatively call the scrollbar's scrolling methods.
 * This ensures that scrolling works even if the default window scrollbar is replaced.
 */
function ScrollToTop({ scrollbarRef }) {
  const location = useLocation();

  useEffect(() => {
    if (!scrollbarRef || !scrollbarRef.current) {
      // Fallback for safety, though ref should always be present
      window.scrollTo(0, 0);
      return;
    }

    if (location.state?.scrollTo) {
      const element = document.querySelector(location.state.scrollTo);
      if (element) {
        // We need to calculate the position relative to the scrollable container
        const top = element.offsetTop;
        scrollbarRef.current.scrollTop(top);
      }
    } else {
      // Default behavior: scroll custom scrollbar to top
      scrollbarRef.current.scrollTop(0);
    }
  }, [location, scrollbarRef]);

  return null;
}

export default ScrollToTop;
